export const SET_AI_SUMMARY_DATA = 'SOCIAL_SENTIMENT/SET_AI_SUMMARY_DATA';
export const SET_INTRA_DAY_GRAPH_DATA = 'SOCIAL_SENTIMENT/SET_INTRA_DAY_GRAPH_DATA';
export const SET_S_SCORE_HISTORY_GRAPH_DATA = 'SOCIAL_SENTIMENT/SET_S_SCORE_HISTORY_GRAPH_DATA';
export const SET_S_VOLUME_HISTORY_GRAPH_DATA = 'SOCIAL_SENTIMENT/SET_S_VOLUME_HISTORY_GRAPH_DATA';
export const SET_SOCIAL_SENTIMENT_TWEETS = 'SOCIAL_SENTIMENT/SET_SOCIAL_SENTIMENT_TWEETS';
export const SET_SOCIAL_SENTIMENT_POPULAR_TWEETS = 'SOCIAL_SENTIMENT/SET_SOCIAL_SENTIMENT_POPULAR_TWEETS';
export const SET_SOCIAL_SENTIMENT_TOP_TOPICS = 'SOCIAL_SENTIMENT/SET_SOCIAL_SENTIMENT_TOP_TOPICS';
export const SET_SOCIAL_SENTIMENT_ACTIVITY = 'SOCIAL_SENTIMENT/SET_SOCIAL_SENTIMENT_ACTIVITY';
export const SET_SOCIAL_SENTIMENT_DOMAIN = 'SOCIAL_SENTIMENT/SET_SOCIAL_SENTIMENT_DOMAIN';
export const SET_SOCIAL_SENTIMENT_WIDGETS_LAYOUT = 'SOCIAL_SENTIMENT/SET_SOCIAL_SENTIMENT_WIDGETS_LAYOUT';

export const setAISummaryData = aISummaryData => ({
  type: SET_AI_SUMMARY_DATA,
  aISummaryData,
});
export const setIntraDayGraphData = intraDayGraphData => ({
  type: SET_INTRA_DAY_GRAPH_DATA,
  intraDayGraphData,
});
export const setSScoreHistoryGraphData = sScoreHistoryGraphData => ({
  type: SET_S_SCORE_HISTORY_GRAPH_DATA,
  sScoreHistoryGraphData,
});
export const setSVolumeHistoryGraphData = sVolumeHistoryGraphData => ({
  type: SET_S_VOLUME_HISTORY_GRAPH_DATA,
  sVolumeHistoryGraphData,
});
export const setSocialSentimentTweets = socialSentimentTweets => ({
  type: SET_SOCIAL_SENTIMENT_TWEETS,
  socialSentimentTweets,
});
export const setSocialSentimentPopularTweets = socialSentimentPopularTweets => ({
  type: SET_SOCIAL_SENTIMENT_POPULAR_TWEETS,
  socialSentimentPopularTweets,
});
export const setSocialSentimentTopTopics = socialSentimentTopTopics => ({
  type: SET_SOCIAL_SENTIMENT_TOP_TOPICS,
  socialSentimentTopTopics,
});
export const setSocialSentimentActivity = socialSentimentActivity => ({
  type: SET_SOCIAL_SENTIMENT_ACTIVITY,
  socialSentimentActivity,
});
export const setSocialSentimentDomain = socialSentimentDomain => ({
  type: SET_SOCIAL_SENTIMENT_DOMAIN,
  socialSentimentDomain,
});
export const setSocialSentimentWidgetsLayout = socialSentimentWidgetsLayout => ({
  type: SET_SOCIAL_SENTIMENT_WIDGETS_LAYOUT,
  socialSentimentWidgetsLayout,
});

const getDefaultState = () => {
  return {
    aISummaryData: null,
    intraDayGraphData: null,
    sScoreHistoryGraphData: null,
    sVolumeHistoryGraphData: null,
    socialSentimentTweets: null,
    socialSentimentPopularTweets: null,
    socialSentimentTopTopics: null,
    socialSentimentActivity: null,
    socialSentimentDomain: null,
    socialSentimentWidgetsLayout: [],
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SET_AI_SUMMARY_DATA:
      return { ...state, aISummaryData: action.aISummaryData };
    case SET_INTRA_DAY_GRAPH_DATA:
      return { ...state, intraDayGraphData: action.intraDayGraphData };
    case SET_S_SCORE_HISTORY_GRAPH_DATA:
      return { ...state, sScoreHistoryGraphData: action.sScoreHistoryGraphData };
    case SET_S_VOLUME_HISTORY_GRAPH_DATA:
      return { ...state, sVolumeHistoryGraphData: action.sVolumeHistoryGraphData };
    case SET_SOCIAL_SENTIMENT_TWEETS:
      return { ...state, socialSentimentTweets: action.socialSentimentTweets };
    case SET_SOCIAL_SENTIMENT_POPULAR_TWEETS:
      return { ...state, socialSentimentPopularTweets: action.socialSentimentPopularTweets };
    case SET_SOCIAL_SENTIMENT_TOP_TOPICS:
      return { ...state, socialSentimentTopTopics: action.socialSentimentTopTopics };
    case SET_SOCIAL_SENTIMENT_ACTIVITY:
      return { ...state, socialSentimentActivity: action.socialSentimentActivity };
    case SET_SOCIAL_SENTIMENT_DOMAIN:
      return { ...state, socialSentimentDomain: action.socialSentimentDomain };
    case SET_SOCIAL_SENTIMENT_WIDGETS_LAYOUT:
      return { ...state, socialSentimentWidgetsLayout: action.socialSentimentWidgetsLayout };

    default:
      break;
  }
  return state;
}
